import { render, staticRenderFns } from "./TrColoring.vue?vue&type=template&id=683cd4d2&scoped=true&"
import script from "./TrColoring.vue?vue&type=script&lang=js&"
export * from "./TrColoring.vue?vue&type=script&lang=js&"
import style0 from "./TrColoring.vue?vue&type=style&index=0&id=683cd4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cd4d2",
  null
  
)

export default component.exports